export default {
    WHITE: 'rgb(255, 255, 255)',
    BLACK: 'rgb(0, 0, 0)',
    RED: 'rgb(255, 11, 12)',
    RED_BROWN: 'rgb(153, 31, 28)',
    GREEN: 'rgb(36, 170, 41)',
    DARK_RED: 'rgb(220, 0, 0)',
    TRANSPARENT: 'transparent',
    URTON_MAIN_COLOR: 'rgb(139, 3, 4)',
    URTON_MAIN_COLOR_WITH_OPACITY: 'rgba(139, 3, 4, 0.8)',
    CLAY_WITH_OPACITY: 'rgba(172, 75, 75, 0.4)',
    DARK_GREY: 'rgb(151, 151, 151)',
    GREY: 'rgb(192, 192, 192)',
    MIDDLE_GREY: 'rgb(210, 210, 210)',
    LIGHT_GREY: 'rgb(229, 229, 229)',
    LIGHT_GREY_WITH_OPACITY: 'rgba(0, 0, 0, 0.6)',
    VERY_LIGHT_GREY: 'rgb(246, 246, 246)',
    GREYISH_BROWN: 'rgb(74, 74, 74)',
    ORANGEY_YELLOW: 'rgb(251, 202, 25)',
    ORANGEY_YELLOW_WITH_OPACITY: 'rgba(251, 202, 25, 0.3)',
    BLUE: 'rgb(0, 0, 255)',
    LIGHT_AZURE: 'rgb(234, 240, 247)',
    SILVER_TWO: 'rgb(212 213 215)',
};